import { combineReducers } from 'redux';
import R from 'ramda';
import moment from 'moment';

const _populateLocs = locations => [
  ...locations.map(loc => ({
    ...loc,
    checked: true,
    access: ['write'],
    products: loc.products.map(prod => ({ ...prod, checked: true })),
  })),
  {
    name: '',
    products: [],
  },
];

const initialState = {
  loading: false,
  creatingTemplates: false,
  dummySupplierForCR: {
    templates: [],
    locations: [],
  },
  rateLoadingWizard: {},
};
export function dummyAcctInCR(state = initialState, { type, payload, args }) {
  switch (type) {
    case '[asset-landing]GET_REQUEST':
    case 'CONTRACT_CONTENT_LOADING':
    case '{rates-draft} REFRESH_POLICIES_NOTES':
      return {
        ...state,
        loading: true,
      };
    case '[asset-landing]GET_REQUEST_SUCCESS':
    case 'GET_CONTRACT_DETAILS':
    case '{rates-draft} REFRESH_POLICIES_NOTES_SUCCESS':
      if (payload.dummySupplierForCR) {
        return {
          ...state,
          crId: payload.contractId,
          startDate: payload.startDate,
          endDate: payload.endDate,
          rateConversionStatus: payload.rateConversionStatus,
          rateConversionSetting: payload.rateConversionSetting,
          priority: payload.priority,
          assignee: payload.assignee,
          buyerCompanyName: payload.from ? payload.from.name : '',
          supplierCompanyName: payload.from ? `${payload.from.name} (RC)` : '',
          buyerEmail: payload.from ? (payload.from.emailAlias || payload.from.email) : '',
          supplierEmails: payload.toEmails.filter(x => x.indexOf('dl+') === -1),
          dummySupplierForCR: payload.dummySupplierForCR,
          rateLoadingWizard: {
            partnerId: payload.to ? payload.to.partnerId : '',
            newDraftStartDate: payload.startDate,
            newDraftEndDate: payload.endDate,
            templateName: `${payload.to && payload.to.name ? payload.to.name : ''} ${
              moment.utc(new Date(payload.startDate)).format('MMM DD YYYY')
            } - ${
              moment.utc(new Date(payload.endDate)).format('MMM DD YYYY')
            } Rates
            `,
            productType: R.path(['dummySupplierForCR', 'productType'], payload) || 'Accommodation',
            oneOrMulti: R.path(['dummySupplierForCR', 'oneOrMulti'], payload) || 'multi',
            locations: R.path(['dummySupplierForCR', 'locations', 'length'], payload)
              ? _populateLocs(R.path(['dummySupplierForCR', 'locations'], payload))
              : [{
                name: payload.to ? payload.to.name : '',
                checked: payload.to ? Boolean(payload.to.name) : false,
                products: [],
              }],
          },
          loading: false,
        };
      }
      return state;
    case '[contract-request] DELETE_RATE_SHEET_SUCCESS':
      return {
        ...state,
        dummySupplierForCR: {
          ...state.dummySupplierForCR,
          templates: (state.dummySupplierForCR.templates || []).filter(o => {
            return o.originalContractId !== args[0].originalContractId;
          }),
        },
      };
    case '[contract-request] UPDATE_RL_WIZARD_DATA':
      return {
        ...state,
        rateLoadingWizard: {
          ...state.rateLoadingWizard,
          ...payload,
        },
      };
    case '[contract-request] UPDATE_RATE_LOADING_STATUS':
      return {
        ...state,
        rateConversionStatus: payload.newStatus,
      };
    case '[asset-landing]GET_REQUEST_ERROR':
    case '{rates-draft} REFRESH_POLICIES_NOTES_ERROR':
      return {
        ...state,
        loading: false,
      };
    case '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR':
      return {
        ...state,
        creatingTemplates: true,
      };
    case '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_SUCCESS':
    case '[contract-request]CREATE_TEMPLATE_IN_DUMMY_ACCOUNT_FOR_CR_ERROR':
      return {
        ...state,
        creatingTemplates: false,
      };
    default:
      return state;
  }
}

export function dummyTemplate(state = {
  crId: '',
  magicLinkHashToken: '',
}, { type, payload }) {
  switch (type) {
    case '@@router/LOCATION_CHANGE':
      const contractId = (window.location.pathname.match(/^\/contracting\/draft\/([a-f\d]{24})\//) || [])[1];
      if (window.location.href.indexOf(process.env.SECONDARY_SYSTEM_URL) > -1 && contractId) {
        if (payload.query && payload.query.magicLinkHashToken) {
          localStorage.setItem(contractId, payload.query.magicLinkHashToken);
          return {
            ...state,
            magicLinkHashToken: payload.query.magicLinkHashToken,
          };
        } else if (localStorage.getItem(contractId)) {
          return {
            ...state,
            magicLinkHashToken: localStorage.getItem(contractId),
          };
        }
      }
      return state;
    default:
      return state;
  }
}

const requestSigsIntial = {
  open: false,
  invitees: [],
  rateDocId: '',
  signatures: [],
  message: '',
  subject: '',
};

export function requestSigs(state = requestSigsIntial, { type, payload }) {
  switch (type) {
    case '{dummy-account}OPEN_REQUEST_SIGNATURE':
      return {
        ...state,
        open: true,
        ...payload,
      };
    case '{dummy-account} REQUEST_SIGNATURE_SUCCESS':
    case '{dummy-account}CANCEL_REQUEST_SIGNATURE':
      return requestSigsIntial;
    case '{dummy-account}UPDATE_PROPS':
      return {
        ...state,
        ...payload,
      };
    case '{dummy-account} REQUEST_SIGNATURE':
      return {
        ...state,
        sending: true,
      };
    case '{dummy-account} REQUEST_SIGNATURE_ERROR':
      return {
        ...state,
        sending: false,
      };
    default:
      return state;
  }
}

const sendMsgIntial = {
  open: false,
  emails: [],
  rateDocIds: [],
  signatures: [],
  leanFiles: [],
  message: '',
  subject: '',
  who: 'Supplier',
  submitRatesChecked: false,
  defaultSubject: '',
  defaultMessage: '',
};

export function sendMsg(state = sendMsgIntial, { type, payload }) {
  switch (type) {
    case '{rl-send-message}OPEN_SEND_MESSAGE':
      return {
        ...state,
        ...payload,
        open: true,
      };
    case 'GET_CONTRACT_DETAILS':
    case '{rates-draft} REFRESH_POLICIES_NOTES_SUCCESS':
      const year = moment.utc(payload.startDate).get('year') === moment.utc(payload.endDate).get('year')
        ? moment.utc(payload.startDate).get('year')
        : `${
          moment.utc(payload.startDate).get('year')
        } - ${
          moment.utc(payload.endDate).get('year')
        }`;
      const defaultSub = payload.to ? `${payload.to.name} ${year} Rates` : '';
      const defaultMsg = payload.to ? `Hi,

Please find ${payload.to.name} ${year} rates below.

If you have any questions please let us know and thank you for your support.

Thanks,

TourConnect Data Conversion Team
      ` : '';
      return {
        ...state,
        defaultSubject: defaultSub,
        defaultMessage: defaultMsg,
      };
    case '{rl-send-message} OPEN_SEND_MESSAGE_AS_SUBMIT_RATES_AS_DL':
      return {
        ...state,
        open: true,
        who: 'Buyer',
        submitRatesChecked: true,
        subject: state.subject || state.defaultSubject,
        message: state.message || state.defaultMessage,
        ...payload,
      };
    case '{rl-send-message} CANCEL_SEND_MESSAGE':
      return {
        ...sendMsgIntial,
        defaultSubject: state.defaultSubject,
        defaultMessage: state.defaultMessage,
      };
    case '{rl-send-message} UPDATE_PROPS':
      return {
        ...state,
        ...payload,
      };
    case '{rl-send-message} SEND_MESSAGE':
    case '{rl-send-message} SUBMIT_RATES_AS_DL':
      return {
        ...state,
        sending: true,
      };
    case '{rl-send-message} SEND_MESSAGE_ERROR':
    case '{rl-send-message} SUBMIT_RATES_AS_DL_ERROR':
      return {
        ...state,
        sending: false,
      };
    case '{rl-send-message} SEND_MESSAGE_SUCCESS':
    case '{rl-send-message} SUBMIT_RATES_AS_DL_SUCCESS':
      return {
        ...state,
        sending: false,
        sent: true,
      };
    default:
      return state;
  }
}


const initialIframe = {
  url: '',
  rateDocId: '',
  collection: '',
  open: false,
  acceptingDummyTemplate: false,
  isInSigning: false,
  buyerLogo: '',
  buyerName: '',
  loading: false,
  deletingDraft: false,
  rawDiffData: [],
  ratesSummary: {},
};

function rateDocIframe(state = initialIframe, { type, payload }) {
  switch (type) {
    case '{dummy-account} RateDocIframe_open':
      // this could be an iframe within iframe (buyer loading rates in their dummy account and previewing rates from another account)
      if (window.location.href.indexOf(process.env.SECONDARY_SYSTEM_URL) > -1) {
        localStorage.setItem('prevJwt', localStorage.getItem('jwt'));
      }
      return {
        ...state,
        open: true,
        ...payload,
      };
    case '{dummy-account} loadDataForIframe':
      return {
        ...state,
        loading: true,
      };
    case '{dummy-account} RateDocIframe_checkIfRateComplete':
      return {
        ...state,
        loading: true,
      };
    case '{dummy-account} RateDocIframe_checkIfRateComplete_SUCCESS':
    case '{dummy-account} loadDataForIframe_SUCCESS':
    case '{dummy-account} loadDraftDiff_SUCCESS':
      return {
        ...state,
        ...payload,
        loading: false,
      };
    case '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT':
      return {
        ...state,
        deletingDraft: true,
      };
    case '{dummy-account} DISCARD_DUMMY_TEMPLATE_DRAFT_SUCCESS':
    case '{dummy-account} ACCEPT_DUMMY_TEMPLATE_SUCCESS':
    case 'RateDocIframe_selectImportTemplate':
    case '{dummy-account} RateDocIframe_close':
      // this could be an iframe within iframe (buyer loading rates in their dummy account and previewing rates from another account)
      if (window.location.href.indexOf(process.env.SECONDARY_SYSTEM_URL) > -1 && localStorage.getItem('prevJwt')) {
        localStorage.setItem('jwt', localStorage.getItem('prevJwt'));
        localStorage.removeItem('prevJwt');
      }
      return initialIframe;
    case '{dummy-account} ACCEPT_DUMMY_TEMPLATE':
      return {
        ...state,
        acceptingDummyTemplate: true,
      };
    default:
      return state;
  }
}
export default combineReducers({
  inCR: dummyAcctInCR,
  dummyTemplate,
  requestSigs,
  sendMsg,
  rateDocIframe,
});



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/__store-files__/reducers.js